var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"d-flex flex-column",attrs:{"fluid":""}},[_c('v-card',{staticClass:"ma-2 pa-2 d-flex flex-column justify-space-between"},[_c('div',{attrs:{"id":"map"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }